import { disposableSubscription } from 'common/barrels/core';
import { readDataContractSerializedJsonDate } from 'common/functions/date';
import { LooklessControl } from 'runtime/controls/looklesscontrol';
import { ControlArgs } from 'runtime/controls/controlargs';
import { registerBinding } from 'runtime/bindingengine';
import { GenericEvent } from 'runtime/events/genericevent';

export class IdScanner extends LooklessControl {
    private respond: boolean;

    constructor(args: ControlArgs) {
        super(args);

        this.methods.register(this.config.elementName, this);

        this.respond = this.config['content.RespondToEvents'];

        var genericEvents = this.eventAggregator.query(GenericEvent).filter(() => this.respond).share();

        this.subscriptions = disposableSubscription(
            genericEvents.filter(x => x.name === 'IdScanned').subscribe(x => this.processScan(x)),
            genericEvents.filter(x => x.name === 'IdScanError').subscribe(() => this.triggerEvent('IdScanError')),
            genericEvents.filter(x => x.name === 'IdScannerOnline').subscribe(() => this.triggerEvent('IdScannerOnline')),
            genericEvents.filter(x => x.name === 'IdScannerOffline').subscribe(() => this.triggerEvent('IdScannerOffline')),
            this.processBindings(this.config)
        );
    }

    startScan() {
        this.eventAggregator.publish(new GenericEvent('StartScan', ''));
    }

    checkScannerStatus() {
        this.eventAggregator.publish(new GenericEvent('CheckScannerStatus', ''));
    }

    'content.RespondToEvents'(value: boolean) {
        this.respond = value;
    }

    'content.FirstName'() { }
    'content.Surname'() { }
    'content.DateOfBirth'() { }
    'content.MiddleName'() { }
    'content.Sex'() { }
    'content.Country'() { }

    private processScan(event: GenericEvent) {
        var payload = JSON.parse(event.payload);
            
        this.$element.triggerHandler('content.FirstName', payload.FirstName);
        this.$element.triggerHandler('content.MiddleName', payload.MiddleName);
        this.$element.triggerHandler('content.Surname', payload.LastName);
        this.$element.triggerHandler('content.DateOfBirth', readDataContractSerializedJsonDate(payload.DateOfBirth));
        this.$element.triggerHandler('content.Sex', payload.Sex);
        this.$element.triggerHandler('content.Country', payload.Country);
        this.triggerEvent('IdScanSuccess');
    }
}

registerBinding('IdScanner', IdScanner);